import { render, staticRenderFns } from "./permissions-editor.vue?vue&type=template&id=481d662a&scoped=true"
import script from "./permissions-editor.vue?vue&type=script&lang=js"
export * from "./permissions-editor.vue?vue&type=script&lang=js"
import style0 from "./permissions-editor.vue?vue&type=style&index=0&id=481d662a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481d662a",
  null
  
)

export default component.exports